import axios from '../../axios'

// 新增职业分布信息
export const addOccupation = (data) => {
    return axios({
        url: '/api/data/wish/occupation',
        method: 'POST',
        data
    })
}

// 修改职业分布信息
export const editOccupation = (data) => {
    return axios({
        url: '/api/data/wish/occupation',
        method: 'PUT',
        data
    })
}

// 删除职业分布信息
export const deleteOccupation = (data) => {
    return axios({
        url: '/api/data/wish/occupation',
        method: 'DELETE',
        data
    })
}

// 根据信息综合搜索职业分布信息列表
export const searchOccupationList = (data) => {
    return axios({
        url: '/api/data/wish/occupation',
        method: 'GET',
        data
    })
}

//  获取职业分布详细信息
export const getOccupationInfo = (data) => {
    return axios({
        url: '/api/data/wish/occupation/info',
        method: 'GET',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/dataManage/occupation.js